import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceWorkgroupModalStore } from './service-workgroup-modal.store';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { FormBuilder, Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import {
    ServiceWorkgroupCreateInput,
} from '@libs/types/src/services/input-type/services/settings/service-workgroup.create-input';
import { ServiceWorkgroupObject } from '@libs/types/src/services/object-type/service/settings/service-workgroup.object';
import {
    ServiceWorkgroupUpdateInput,
} from '@libs/types/src/services/input-type/services/settings/service-workgroup.update-input';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { ColorInputComponent } from '../../../../../../components/kit/input/color-input/color-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-workgroup-modal',
    templateUrl: 'service-workgroup-modal.component.html',
    styleUrl: 'service-workgroup-modal.component.scss',
    providers: [ServiceWorkgroupModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        TextInputComponent,
        CheckInputComponent,
        ColorInputComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceWorkgroupModalComponent extends SubscriptionComponent {

    protected readonly store = inject(ServiceWorkgroupModalStore);
    private readonly fb = inject(FormBuilder);

    @Input() workgroup: ServiceWorkgroupObject | null = null;

    protected visible = false;

    protected form = this.fb.group({
        active: this.fb.control<boolean>(true),
        name: this.fb.control<string>('', Validators.required),
        description: this.fb.control<string>(''),
        color: this.fb.control<string | null>('#ff0000'),
    });

    constructor() {
        super();
        this.store.registerSuccessMessage('createServiceWorkgroup', 'common.created');
        this.store.registerSuccessMessage('updateServiceWorkgroup', 'common.updated');
    }

    public show(visible: boolean = true, workgroup: ServiceWorkgroupObject | null = null): void {
        this.visible = visible;
        this.workgroup = workgroup;
        if (workgroup) {
            this.form.patchValue(workgroup);
        }
    }

    protected async submit(): Promise<void> {
        if (isInvalid(this.form)) return;

        if (!this.workgroup) {
            const serviceId = Number(this.store.routeParam.serviceId.value);
            this.store.api.createServiceWorkgroup({
                serviceId,
                ...this.form.value,
            } as ServiceWorkgroupCreateInput);
        } else {
            this.store.api.updateServiceWorkgroup({
                id: this.workgroup!.id,
                ...this.form.value,
            } as ServiceWorkgroupUpdateInput);
        }

        this.show(false);
    }

}
